<template>
  <div class="my">
    <!--头部-->
    <Navbar :isNotify="false" :isCustomerService="false" :showLeft="false">
      <template #left>
        <div class="left-content">
          <div class="text">
            <span style="font-weight: 600">前程乐享</span>
            <span class="tip">应急不用等 周转更轻松</span>
          </div>
        </div>
      </template>
      <template #right>
        <div class="right-content">
          <img
            @click="handleClickNotify"
            class="notifyIcon"
            src="@/assets/style/notify-icon.png"
            alt=""
          />
          <img
            @click="handleClickCustomerService"
            class="customerServiceIcon"
            src="@/assets/style/customer-service-icon.png"
            alt=""
          />
        </div>
      </template>
    </Navbar>
    <!--内容区域-->
    <div class="content">
      <!--用户信息-->
      <userInfo />
      <!--菜单列表-->
      <menuList />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import userInfo from "@/components/my/userInfo.vue";
import menuList from "@/components/my/menuList.vue";
import { getPersonalInfo } from "@/api/index";

export default {
  name: "My",
  components: {
    userInfo,
    menuList,
    Navbar,
  },
  data() {
    return {};
  },
  async mounted() {
    document.documentElement?.style?.setProperty?.('--status-bar-bg', '#fff2ea');
    //获取个人信息
    const res = await getPersonalInfo();
    if (res.code === 2000) {
      this.$store.commit("setUserInfo", {
        ...this.$store.state.userInfo,
        ...res.data,
      });
    }
  },
  methods: {
    handleClickNotify() {
      this.$router.push({ name: "notify" });
    },
    handleClickCustomerService() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
         const clientId = localStorage.getItem("phone") ? `phone_${localStorage.getItem("phone")}` : "";
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=7db6e8d0-6ed3-11f1-acd0-59b3051d5398&clientId=${clientId}&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN`,
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.my {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background-color: #fff;
  background-image: url("@/assets/style/my/my-bg.png");
  background-size: 100% 30%;
  background-repeat: no-repeat;
}
.my.is-overlapped {
  ::v-deep(.van-nav-bar) {
    background: #0d63ef !important;
  }
  ::v-deep(.van-nav-bar__title) {
    color: #fff;
  }
}
::v-deep(.van-nav-bar__content) {
  height: 56px !important;
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
::v-deep(.van-nav-bar) {
  background: transparent !important;
}
.left-content {
  display: flex;
  font-size: 18px;
  font-family: "Regular";
  color: #573119;
  align-items: center;
  .guide-logo-icon {
    height: 32px;
  }
  .text {
    padding-left: 3px;
    display: flex;
    flex-direction: column;
  }
  span {
    text-align: left;
  }
  .tip {
    font-size: 11px;
    margin-top: -5px;
  }
}
.right-icons {
  display: flex;
}
.notifyIcon {
  width: 24px;
  height: 24px;
}
.content {
  margin-top: 14px;
  padding: 0 16px;
}
.customerServiceIcon {
  width: 24px;
  height: 24px;
  padding-left: 24px;
}
</style>
